import "./work-fahrlygo.css";
import OurWorksSection from "../../../components/our-works-section/OurWorksSection";

function WorkFahrlygo() {
  const id = 8;

  return (
    <div className="work fahrlygo">
      {/* Work Header */}
      <div className="work-header">
        <div className="work-branding">
          <div className="work-branding-title">
            <div className="work-branding-title-col-1">
              {window.innerWidth <= 768 ?
                <img
                  src="/assets/icons/partner-companies-logos/fahrlygo-2.svg"
                  alt="Fahrly Logo"
                /> :
                <h2
                  className="animate__animated animate__fadeIn animate__slow"
                  style={{ color: "#FF5611" }}
                >
                  <span>Fahrly Go - </span> Taxi Booking App
                </h2>
              }
              {window.innerWidth <= 768 ?
                <h2
                  className="animate__animated animate__fadeIn animate__slow"
                  style={{ color: "#FF5611" }}
                >
                  <span>Fahrly Go - </span> Taxi Booking App
                </h2>
                :
                <button
                  onClick={() => window.open("https://apps.apple.com/ge/app/fahrlygo/id1670873916", "_blank")}
                >
                  <img src="/assets/icons/appstore.svg" alt="Appstore Logo" />
                </button>
              }
            </div>
            <div
              className={`work-branding-title-col-2  ${window.innerWidth <= 768 ? "d-none" : ""
                }`}
            >
              <img
                src="/assets/icons/partner-companies-logos/fahrlygo-2.svg"
                alt="Fahrly Logo"
              />
            </div>
          </div>
          <h1
            className={`animate__animated animate__fadeIn animate__slow ${window.innerWidth <= 768 ? "d-none" : ""
              }`}
          >
            Discover the groundbreaking tool for rental car drivers worldwide With our revolutionary Instant Push Notification!
          </h1>
        </div>

        <div className="work-main-img">
          <div className="work-main-img-content-gradient"></div>
          <img
            src="/assets/images/work-pages/fahrlygo/fahrlygo-1.webp"
            alt="Work Image"
          />

          <div
            className={`work-main-img-content`}
          >
            <img
              src="/assets/images/work-pages/fahrlygo/fahrlygoicon.svg"
              alt=""
            />
            <h1>
              <span className="bold">Fahrly</span> GO!
            </h1>

            <div className="work-main-img-content-heading">
              <h1>
                <span className="bold">Fahrly</span> GO makes getting an Taxi Booking
              </h1>
              <div className="d-flex align-items-center justify-content-center">
                <h1>App more Fexible</h1>
              </div>
            </div>
          </div>

          <div className="work-main-img-content-gradient"></div>
        </div>

        <h1 className={`${window.innerWidth > 768 ? "d-none" : ""}`}>
          Discover the groundbreaking tool for rental car drivers worldwide With our revolutionary Instant Push Notification!
        </h1>

        <button
          className={`${window.innerWidth > 768 ? "d-none" : ""}`}
          onClick={() => window.open("https://apps.apple.com/ge/app/fahrlygo/id1670873916", "_blank")}
        >
          <img src="/assets/icons/appstore.svg" alt="Appstore Logo" />
        </button>
      </div>

      {/* Work Desc Section */}
      <div className="work-desc-section">
        <div className="work-desc">
          <p>
            FAHRLYGO brings ride information, vehicle management, and financial tracking into one seamless interface. Receive up-to-the-minute
          </p>
          <p className={`${window.innerWidth <= 768 ? "d-none" : ""}`}>
            Details about pickups, drop-offs, and pricing. Submit vehicle information like mileage, fuel levels, and images with ease, and efficiently report any damages. Manage your finances by recording expenses and incomes directly in the app. With FahrlyGO, stay on top of your driving business with streamlined processes and intuitive navigation.
          </p>
        </div>
        <div
          className={`work-provided-services ${window.innerWidth <= 768 ? "d-none" : ""
            }`}
        >
          <h2>Services we provided</h2>
          <ul>
            <li>Analytic Driven Iterations</li>
            <li>Market Research</li>
            <li>Information Architecture</li>
            <li>Wireframing</li>
            <li>Navigation Usability</li>
            <li>Mobile App Design</li>
            <li>UX/UI</li>
          </ul>
        </div>
      </div>

      {/* Work Section 1 */}
      <div className="work-section-1">
        <h1 className={`${window.innerWidth <= 768 ? "d-none" : ""}`}>
          Introducing FahrlyGO, the essential app for drivers connected to a Mietwagenzentrale or Dispatch.
        </h1>
        <img
          src="/assets/images/work-pages/fahrlygo/fahrlygo-2.webp"
          alt="Work Image"
        />

        <div
          className={`work-provided-services ${window.innerWidth > 768 ? "d-none" : ""
            }`}
        >
          <h2>Services we provided</h2>
          <ul>
            <li>Analytic Driven Iterations</li>
            <li>Market Research</li>
            <li>Information Architecture</li>
            <li>Wireframing</li>
            <li>Navigation Usability</li>
            <li>Mobile App Design</li>
            <li>UX/UI</li>
          </ul>
        </div>

        <p className={`${window.innerWidth > 768 ? "d-none" : ""}`}>
          Details about pickups, drop-offs, and pricing. Submit vehicle information like mileage, fuel levels, and images with ease, and efficiently report any damages. Manage your finances by recording expenses and incomes directly in the app. With FahrlyGO, stay on top of your driving business with streamlined processes and intuitive navigation.
        </p>
      </div>

      {/* Work Section 2 */}
      <div className="work-section-2">
        <h1>Maximize Your Earnings As A Rental Car Driver! </h1>
        <p className={`${window.innerWidth <= 768 ? "d-none" : ""}`}>
          Our app makes ordering a taxi easier and more convenient: · – the ride price is known in advance, helping you to plan out your expenses; · – scheduled orders.
        </p>
        <p className={`${window.innerWidth <= 768 ? "d-none" : ""}`}>
          The installation of FahrlyGO - Power für Fahrer! may fail because of the lack of device storage, poor network connection, or the compatibility of your Android device. Therefore, please check the minimum requirements first to make sure FahrlyGO - Power für Fahrer! is compatible with your phone.
        </p>
        <p className={`${window.innerWidth <= 768 ? "d-none" : ""}`}>
          APKPure provides the latest version and all the older versions of FahrlyGO - Power für Fahrer!. You can download any version you want from here: All Versions of FahrlyGO - Power für Fahrer , FahrlyGO - Power für Fahrer! is safe to download on APKPure, as it has a trusted and verified digital signature from its developer it  takes up around 39.0 MB of storage. It's recommended to download APKPure App to install FahrlyGO - Power für Fahrer! successfully on your mobile device with faster speed.
        </p>
        <img
          src="/assets/images/work-pages/fahrlygo/fahrlygo-3.webp"
          alt="Work Image"
        />
        <div className="d-flex justify-content-center">
          <img
            src="/assets/images/work-pages/fahrlygo/fahrlygo-4.webp"
            alt="Work Image"
          />
          <img
            src="/assets/images/work-pages/fahrlygo/fahrlygo-5.webp"
            alt="Work Image"
          />
        </div>

        <p className={`${window.innerWidth > 768 ? "d-none" : ""}`}>
          Our app makes ordering a taxi easier and more convenient: · – the ride price is known in advance, helping you to plan out your expenses; · – scheduled orders.
        </p>
        <p className={`${window.innerWidth > 768 ? "d-none" : ""}`}>
          The installation of FahrlyGO - Power für Fahrer! may fail because of the lack of device storage, poor network connection, or the compatibility of your Android device. Therefore, please check the minimum requirements first to make sure FahrlyGO - Power für Fahrer! is compatible with your phone.
        </p>
        <p className={`${window.innerWidth > 768 ? "d-none" : ""}`}>
          APKPure provides the latest version and all the older versions of FahrlyGO - Power für Fahrer!. You can download any version you want from here: All Versions of FahrlyGO - Power für Fahrer , FahrlyGO - Power für Fahrer! is safe to download on APKPure, as it has a trusted and verified digital signature from its developer it  takes up around 39.0 MB of storage. It's recommended to download APKPure App to install FahrlyGO - Power für Fahrer! successfully on your mobile device with faster speed.
        </p>
      </div>

      {/* Work Section 3 */}
      <div className="work-section-3">
        <h1>The Results</h1>
        <img
          className={`${window.innerWidth > 768 ? "d-none" : ""}`}
          src="/assets/images/work-pages/fahrlygo/fahrlygo-6.webp"
          alt="Work Image"
        />
        <p>
          The on-demand alternative to Farley taxis is here. With the Uber app, riders and private-hire drivers connect 24/7. Convenience is prioritised every step of the way, starting with booking a ride.
          <br />
          All it takes is a few taps to get started. Download the mobile app, enter your pick-up and drop-off addresses, then select Farlghygox to confirm your ride in Farley.
        </p>
        <h2>
          FahrlyGO: Maximize your earnings as a rental car driver! Download the latest version of FahrlyGO - to enjoy new features and updates immediately!
        </h2>
        <img
          className={`${window.innerWidth <= 768 ? "d-none" : ""}`}
          src="/assets/images/work-pages/fahrlygo/fahrlygo-6.webp"
          alt="Work Image"
        />
      </div>

      <OurWorksSection workPageId={id} />
    </div>
  );
}

export default WorkFahrlygo;
